import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";

const Title = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={0}
      height={40}
      color={""}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={28}
        isSpan={true}
        text={i18n.get("CREATE_ONE_O_ONE_M")}
        style={{
          height: 40 * unitY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        color={""}
      />
    </ET3Div>
  );
});

export default Title;
